import type React from "react";
import { AcquisitionDefault } from "./AcquisitionDefault";

export const AcquisitionModuleHomePage: React.FC = () => {
    return <AcquisitionDefault />;
};
